import { render, staticRenderFns } from "./PostComponent.vue?vue&type=template&id=32a8cc9b&scoped=true&"
import script from "./PostComponent.vue?vue&type=script&lang=js&"
export * from "./PostComponent.vue?vue&type=script&lang=js&"
import style0 from "./PostComponent.vue?vue&type=style&index=0&id=32a8cc9b&lang=scss&scoped=true&"
import style1 from "./PostComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a8cc9b",
  null
  
)

export default component.exports